import { FixedColumnPosition, TableRefreshButtonEnum, UiTableConfig } from '@ui-kit/table/_core';
import { FeeWaiversTableColumnEnum, feeWaiversTableColumnText } from '../types';

export function feeWaiversTableConfig(): UiTableConfig<FeeWaiversTableColumnEnum, any> {
    return {
        dataTrackBy: 'feeWaiverId',
        hasEmptyEnd: false,
        emptyStateText: 'groups.feeWaivers.table.emptyState',
        refreshButtonTableType: TableRefreshButtonEnum.FEE_WAIVERS_TABLE,
        columns: [
            {
                field: FeeWaiversTableColumnEnum.Fee_WAIVER_NAME,
                key: 'name',
                name: feeWaiversTableColumnText[FeeWaiversTableColumnEnum.Fee_WAIVER_NAME],
                centered: false,
                width: '18vw',
                minWidth: '200px',
                maxWidth: '300px',
                isVisible: true,
                inSearchResults: true,
                canBeUncheckedOnColumnsArrangementPanel: true,
                orderPriority: 1,
                widthRatio: 1,
                customTemplate: 'feeWaiverName',
            },
            {
                field: FeeWaiversTableColumnEnum.CREATED_BY,
                key: 'createdBy',
                name: feeWaiversTableColumnText[FeeWaiversTableColumnEnum.CREATED_BY],
                centered: false,
                width: '15vw',
                minWidth: '150px',
                maxWidth: '250px',
                isVisible: true,
                canBeUncheckedOnColumnsArrangementPanel: true,
                inSearchResults: true,
                orderPriority: 2,
                widthRatio: 1,
                customTemplate: 'createdByUser',
            },
            {
                field: FeeWaiversTableColumnEnum.DATE_CREATED,
                key: 'dateCreated',
                name: feeWaiversTableColumnText[FeeWaiversTableColumnEnum.DATE_CREATED],
                centered: false,
                width: '10vw',
                minWidth: '130px',
                maxWidth: '150px',
                isVisible: true,
                inSearchResults: true,
                canBeUncheckedOnColumnsArrangementPanel: true,
                orderPriority: 3,
                widthRatio: 1,
                dateTimeInfo: true,
            },
            {
                field: FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG,
                key: 'totalGroupsCount',
                name: feeWaiversTableColumnText[FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG],
                centered: true,
                width: '10vw',
                minWidth: '145px',
                maxWidth: '145px',
                isVisible: true,
                inSearchResults: true,
                canBeUncheckedOnColumnsArrangementPanel: true,
                orderPriority: 4,
                widthRatio: 1,
                infoTooltipText: 'Unique groups with the waiver as expired, upcoming or active',
            },
            {
                field: FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG_ACTIVE,
                key: 'activeGroupsCount',
                name: feeWaiversTableColumnText[FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG_ACTIVE],
                centered: true,
                width: '10vw',
                minWidth: '150px',
                maxWidth: '150px',
                isVisible: true,
                inSearchResults: true,
                canBeUncheckedOnColumnsArrangementPanel: true,
                orderPriority: 5,
                widthRatio: 1,
                infoTooltipText: 'Unique groups with the waiver as active',
            },
            {
                field: FeeWaiversTableColumnEnum.ACTIONS,
                key: '',
                name: '',
                centered: true,
                hiddenInColumnsPanel: true,
                fixedColumnPosition: FixedColumnPosition.LAST,
                width: '10vw',
                minWidth: '60px',
                maxWidth: '200px',
                isVisible: true,
                hasRefreshButton: true,
                widthRatio: 1,
                customTemplate: 'actionsColumn',
            },
        ],
    };
}
